import { t } from "@lingui/macro";
import { useSetAtom } from "jotai";

import { TrashIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { removeRoundFromBookingAtom } from "../../../../../../../../../atoms/actions/removeRoundFromBookingAtom/removeRoundFromBookingAtom";

type RemoveRoundMenuItemProps = {
  roundId: string;
};

export const RemoveRoundMenuItem = ({ roundId }: RemoveRoundMenuItemProps) => {
  const removeRound = useSetAtom(removeRoundFromBookingAtom);

  return (
    <>
      <Pressable onPress={() => removeRound(roundId)}>
        <HStack gap={3} paddingHorizontal={4} paddingVertical={3}>
          <TrashIcon color="status-error-500" />
          <Text color="text-error">{t`Remove`}</Text>
        </HStack>
      </Pressable>
    </>
  );
};
